import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import { ChildTab } from "../ChildTab";
import { useState } from "react";
import { SubNavListModalProps } from "../../Types";
import { Popover } from "@mui/material";
import { PopoverOrigin } from "@material-ui/core";

const SubNavListModal = (props: SubNavListModalProps) => {
  const { subNavLinkList, isParentTabActive, activeSubTabId, anchorEl, setAnchorEl } = props;

  const [hoveredSubTabId, setHoverSubTabId] = useState(null);
  const [anchorElLocal, setAnchorElLocal] = useState(null);

  return (
    <Popover
      anchorEl={anchorEl}
      open={!!anchorEl}
      anchorOrigin={
        {
          vertical: "center",
          horizontal: "right",
        } as PopoverOrigin
      }
      transformOrigin={{
        vertical: "center",
        horizontal: "left",
      }}
      classes={{
        paper: `!tw-rounded-md !tw-overflow-visible  !tw-p-0 !tw-ml-[10px] !tw-bg-transparent !tw-shadow-none`,
        root: "!tw-static !tw-w-fit !tw-h-fit",
      }}
      onClose={() => setAnchorEl(null)}
    >
      <div className="tw-relative tw-ml-[12px] tw-flex  tw-items-center tw-rounded-xl tw-bg-white !tw-shadow-[1px_2px_8px_0px_#00000026]">
        <ArrowLeftIcon className="tw-absolute tw-right-full tw-translate-x-[45%] tw-text-white" fontSize="large" />
        <div className="tw-min-w-[157px] tw-py-[8px]">
          {subNavLinkList.map((subNavListItem) => 
            <ChildTab
              key={subNavListItem.id}
              subNavListItem={subNavListItem}
              isParentTabActive={isParentTabActive}
              activeSubTabId={activeSubTabId}
              activeHoveredSubTabId={hoveredSubTabId}
              onHoverSubTab={setHoverSubTabId}
              isDropdown={false}
              anchorEl={anchorElLocal}
              setAnchorEl={setAnchorElLocal}
            />,
          )}
        </div>
      </div>
    </Popover>
  );
};

export default SubNavListModal;
